// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { PlayEventTypeWire } from '../mannequin/play-event-type-wire';


export class TrackedEventWire implements flatbuffers.IUnpackableObject<TrackedEventWireT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):TrackedEventWire {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsTrackedEventWire(bb:flatbuffers.ByteBuffer, obj?:TrackedEventWire):TrackedEventWire {
  return (obj || new TrackedEventWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsTrackedEventWire(bb:flatbuffers.ByteBuffer, obj?:TrackedEventWire):TrackedEventWire {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new TrackedEventWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

timestamp():string|null
timestamp(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
timestamp(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

batSide():string|null
batSide(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
batSide(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

pitchHand():string|null
pitchHand(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
pitchHand(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

atBatNumber():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
}

pitchNumber():number {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
}

pickoffNumber():number {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
}

szTop():number {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

szBot():number {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

eventType():string|null
eventType(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
eventType(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

x():number {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

y():number {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

z():number {
  const offset = this.bb!.__offset(this.bb_pos, 26);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

position():number {
  const offset = this.bb!.__offset(this.bb_pos, 28);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
}

eventTypeId():PlayEventTypeWire {
  const offset = this.bb!.__offset(this.bb_pos, 30);
  return offset ? this.bb!.readInt8(this.bb_pos + offset) : PlayEventTypeWire.BEGIN_OF_PLAY;
}

static startTrackedEventWire(builder:flatbuffers.Builder) {
  builder.startObject(14);
}

static addTimestamp(builder:flatbuffers.Builder, timestampOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, timestampOffset, 0);
}

static addBatSide(builder:flatbuffers.Builder, batSideOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, batSideOffset, 0);
}

static addPitchHand(builder:flatbuffers.Builder, pitchHandOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, pitchHandOffset, 0);
}

static addAtBatNumber(builder:flatbuffers.Builder, atBatNumber:number) {
  builder.addFieldInt16(3, atBatNumber, 0);
}

static addPitchNumber(builder:flatbuffers.Builder, pitchNumber:number) {
  builder.addFieldInt16(4, pitchNumber, 0);
}

static addPickoffNumber(builder:flatbuffers.Builder, pickoffNumber:number) {
  builder.addFieldInt16(5, pickoffNumber, 0);
}

static addSzTop(builder:flatbuffers.Builder, szTop:number) {
  builder.addFieldFloat32(6, szTop, 0.0);
}

static addSzBot(builder:flatbuffers.Builder, szBot:number) {
  builder.addFieldFloat32(7, szBot, 0.0);
}

static addEventType(builder:flatbuffers.Builder, eventTypeOffset:flatbuffers.Offset) {
  builder.addFieldOffset(8, eventTypeOffset, 0);
}

static addX(builder:flatbuffers.Builder, x:number) {
  builder.addFieldFloat32(9, x, 0.0);
}

static addY(builder:flatbuffers.Builder, y:number) {
  builder.addFieldFloat32(10, y, 0.0);
}

static addZ(builder:flatbuffers.Builder, z:number) {
  builder.addFieldFloat32(11, z, 0.0);
}

static addPosition(builder:flatbuffers.Builder, position:number) {
  builder.addFieldInt16(12, position, 0);
}

static addEventTypeId(builder:flatbuffers.Builder, eventTypeId:PlayEventTypeWire) {
  builder.addFieldInt8(13, eventTypeId, PlayEventTypeWire.BEGIN_OF_PLAY);
}

static endTrackedEventWire(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createTrackedEventWire(builder:flatbuffers.Builder, timestampOffset:flatbuffers.Offset, batSideOffset:flatbuffers.Offset, pitchHandOffset:flatbuffers.Offset, atBatNumber:number, pitchNumber:number, pickoffNumber:number, szTop:number, szBot:number, eventTypeOffset:flatbuffers.Offset, x:number, y:number, z:number, position:number, eventTypeId:PlayEventTypeWire):flatbuffers.Offset {
  TrackedEventWire.startTrackedEventWire(builder);
  TrackedEventWire.addTimestamp(builder, timestampOffset);
  TrackedEventWire.addBatSide(builder, batSideOffset);
  TrackedEventWire.addPitchHand(builder, pitchHandOffset);
  TrackedEventWire.addAtBatNumber(builder, atBatNumber);
  TrackedEventWire.addPitchNumber(builder, pitchNumber);
  TrackedEventWire.addPickoffNumber(builder, pickoffNumber);
  TrackedEventWire.addSzTop(builder, szTop);
  TrackedEventWire.addSzBot(builder, szBot);
  TrackedEventWire.addEventType(builder, eventTypeOffset);
  TrackedEventWire.addX(builder, x);
  TrackedEventWire.addY(builder, y);
  TrackedEventWire.addZ(builder, z);
  TrackedEventWire.addPosition(builder, position);
  TrackedEventWire.addEventTypeId(builder, eventTypeId);
  return TrackedEventWire.endTrackedEventWire(builder);
}

unpack(): TrackedEventWireT {
  return new TrackedEventWireT(
    this.timestamp(),
    this.batSide(),
    this.pitchHand(),
    this.atBatNumber(),
    this.pitchNumber(),
    this.pickoffNumber(),
    this.szTop(),
    this.szBot(),
    this.eventType(),
    this.x(),
    this.y(),
    this.z(),
    this.position(),
    this.eventTypeId()
  );
}


unpackTo(_o: TrackedEventWireT): void {
  _o.timestamp = this.timestamp();
  _o.batSide = this.batSide();
  _o.pitchHand = this.pitchHand();
  _o.atBatNumber = this.atBatNumber();
  _o.pitchNumber = this.pitchNumber();
  _o.pickoffNumber = this.pickoffNumber();
  _o.szTop = this.szTop();
  _o.szBot = this.szBot();
  _o.eventType = this.eventType();
  _o.x = this.x();
  _o.y = this.y();
  _o.z = this.z();
  _o.position = this.position();
  _o.eventTypeId = this.eventTypeId();
}
}

export class TrackedEventWireT implements flatbuffers.IGeneratedObject {
constructor(
  public timestamp: string|Uint8Array|null = null,
  public batSide: string|Uint8Array|null = null,
  public pitchHand: string|Uint8Array|null = null,
  public atBatNumber: number = 0,
  public pitchNumber: number = 0,
  public pickoffNumber: number = 0,
  public szTop: number = 0.0,
  public szBot: number = 0.0,
  public eventType: string|Uint8Array|null = null,
  public x: number = 0.0,
  public y: number = 0.0,
  public z: number = 0.0,
  public position: number = 0,
  public eventTypeId: PlayEventTypeWire = PlayEventTypeWire.BEGIN_OF_PLAY
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const timestamp = (this.timestamp !== null ? builder.createString(this.timestamp!) : 0);
  const batSide = (this.batSide !== null ? builder.createString(this.batSide!) : 0);
  const pitchHand = (this.pitchHand !== null ? builder.createString(this.pitchHand!) : 0);
  const eventType = (this.eventType !== null ? builder.createString(this.eventType!) : 0);

  return TrackedEventWire.createTrackedEventWire(builder,
    timestamp,
    batSide,
    pitchHand,
    this.atBatNumber,
    this.pitchNumber,
    this.pickoffNumber,
    this.szTop,
    this.szBot,
    eventType,
    this.x,
    this.y,
    this.z,
    this.position,
    this.eventTypeId
  );
}
}
